export default {
  methods: {
    resolveRoute(name) {
      return this.$router.resolve({ name })?.href || '';
    },
    goRoute(name) {
      this.$router.push({ name });
    },
    getLink({ route, url }) {
      return route ? this.$router.resolve(route).href || '#' : url || '#';
    },
    navigateToUrl(url) {
      window.location.href = url;
    },
  },
};
